import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { Accordion, Box, Grid, Backdrop } from "@material-ui/core";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import {
  addGateEnteryAction,
  getPreviousGateEntryDocs,
  updateGatryAction,
} from "src/app-redux/vehicle/actions/vehicleActions";
import Heading from "./Heading";
import { useStyles } from "./styles";
import { VehicleDriverDetailsInputs, IForm } from "./VehicleDriverDetailsInputs";
import Drawer from "./Drawer";
import {
  setExistingGateEntryDocs,
  setSelectedGatePassId,
  setExpandNextSection,
} from "src/app-redux/vehicle/vehicleSlice";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function VehicleDriverDetails({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [loader2] = useState(false);
  const [vehicleRecord, setvehicleRecord] = useState({});
  const [vehicleConfiguration, setvehicleConfiguration] = useState({});
  const { id } = useParams<{ id: any }>();
  const [pageHeading] = useState("Gate-Entry Form");
  const history = useHistory();
  const [currentGatePassId, setCurrentGatePassId] = useState(0);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
    history.push(`/gate-entry/gate-entry-details/${currentGatePassId}`); // Return to DetaisPage
    dispatch(setExpandNextSection(true));
  };

  const getVehicleDriverDetails = async (id: any) => {
    try {
      setLoader(true);
      const results = await fetchWrapper.get(`gate-entry-details-by-id/${id}`);
      if (results.isSuccess === true) {
        setvehicleRecord(results.value.gateEntryDetail);
        return;
      }
    } catch (error: any) {
      setLoader(false);
    }
  };
  const getVehicleConfiguration = async () => {
    try {
      setLoader(true);
      const results = await fetchWrapper.get("get-all-vehicle-configuration");
      if (results.isSuccess === true) {
        setvehicleConfiguration(results.value);
        return setLoader(false);
      }
    } catch (error: any) {
      setLoader(false);
    }
  };
  const updateSubmit = async (formData: IForm) => {
    setLoader(true);
    const clone = JSON.parse(JSON.stringify(formData));
    await dispatch(updateGatryAction(clone));
    setLoader(false);
  };
  const handleSubmit = async (formData: IForm) => {
    setLoader(true);
    const clone = JSON.parse(JSON.stringify(formData));
    const res: any = await dispatch(addGateEnteryAction(clone));
    if (res.payload) {
      setCurrentGatePassId(res.payload);
      dispatch(setSelectedGatePassId(res.payload));
      if (formData.gatePassId) {
        const docsRes: any = await dispatch(getPreviousGateEntryDocs(formData.vehicleRegNumber));
        if (docsRes?.payload && docsRes?.payload.gateEntryDocList.length) {
          dispatch(setExistingGateEntryDocs(docsRes.payload.gateEntryDocList));
          setisDrawerOpen(true);
        } else {
          history.push(`/gate-entry/gate-entry-details/${res.payload}`); // Return to DetaisPage
          dispatch(setExpandNextSection(true));
        }
      } else {
        history.push(`/gate-entry/gate-entry-details/${res.payload}`); // Return to DetaisPage
        dispatch(setExpandNextSection(true));
      }
    }
    setLoader(false);
  };
  const handlePanelChange = () => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    updateExpandStatus(0);
    if (isExpanded) {
      getVehicleConfiguration();
      if (id !== 0 && id !== null && id !== undefined) getVehicleDriverDetails(id);
    }
  };
  useEffect(() => {
    getVehicleConfiguration();
    if (id !== 0 && id !== null && id !== undefined) getVehicleDriverDetails(id);
  }, []);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader || loader2}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={handlePanelChange()}>
          <Heading heading={pageHeading} />

          <Grid container direction="row">
            <Grid item xs={12} md={12}>
              {/* Conent Start */}
              <VehicleDriverDetailsInputs
                handleSubmit={handleSubmit}
                updateSubmit={updateSubmit}
                initialValues={vehicleRecord}
                vehicleConfiguration={vehicleConfiguration}
              />
              {/* Conent End */}
            </Grid>
          </Grid>
        </Accordion>
      </Box>
    </>
  );
}
